import { TENANT_ID } from '../../../models/tenant/tenant-id'
import { getClient } from '../DEFAULT'

const apiContext = getClient(TENANT_ID.NATURA_MALAYSIA)

export default {
  client: apiContext.client,
  urls: apiContext.urls
}
